import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskSceneC: any = null,
    titleSceneC: any = null;
export default function D() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const SITE_JP = 'jp';

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (maskSceneC) {
                    AniContainer.removeScene(maskSceneC);
                    maskSceneC = null;
                }
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                // maskSceneC = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-D .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.dpu-detail-D',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleSceneC = AniContainer.create({
                //     asyncFromTo: [['.dpu-detail-D .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.dpu-detail-D',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });
                const pageHeight = window.innerHeight;
                const clientH = (pageHeight || 0) * 0.2;

                const startH = window.innerWidth <= 1024 ? -(pageHeight * 0.5) : Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.dpu-detail-D .sticky-box',
                    triggerHook: 0,
                    offset: startH,
                    duration: window.innerHeight * 2,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (maskSceneC) {
                    AniContainer.removeScene(maskSceneC);
                    maskSceneC = null;
                }
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-D dpu-detail-section ${css['dpu-detail-D']}`}>
            <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                <div className="img-box">
                    <EFPicture
                        src={`/responsive/picture/delta-pro-ultra/launch/4${locale === SITE_JP ? '_jp' : ''}.jpg`}
                        srcPad={`/responsive/picture/delta-pro-ultra/launch/4${locale === SITE_JP ? '_jp' : '_768'}.jpg`}
                        srcMobile={`/responsive/picture/delta-pro-ultra/launch/4${locale === SITE_JP ? '_jp' : '_768'}.jpg`}
                        alt={t('secD_title')}
                    />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secD_title')}</h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
